var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19.513,
    viewBox: "0 0 23 19.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255",
    transform: "translate(-2440.985 1862.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M12.388,441.884c-.08,0-.156,0-.23,0l-.6,3.063a.674.674,0,1,0,1.322.261l.675-3.42a7.094,7.094,0,0,1-1.161.1h0Z",
    transform: "translate(2429.866 -2289.222)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M170.72,460.66h1.928v.4H170.72Z",
    transform: "translate(2275.823 -2307.408)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M418.168,16.662h7.326l-6.034,1.54V34.749l.031-.008,7.039-1.8h1.592v-.4h-1.152V16.3h-9.162v7.663a2.826,2.826,0,0,0,.361.117Zm1.956,8.785.542-.181V28.7l-.542.181Z",
    transform: "translate(2035.864 -1879.29)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M363.006,279.144h-.84v-6.755q-.184-.03-.361-.074V279.2H359.68v.4h3.326Z",
    transform: "translate(2092.924 -2125.947)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M211.374,167.058a11.341,11.341,0,0,0,1.107,1.219,4.08,4.08,0,0,0,2.094.973.539.539,0,0,0,.618-.446.539.539,0,0,0-.446-.618,3.02,3.02,0,0,1-1.268-.5,6.288,6.288,0,0,1-1.2-1.236,3.452,3.452,0,0,0-.637-.614,1.644,1.644,0,0,0-.833-.3.524.524,0,0,0-.062,0h-.5a1.649,1.649,0,0,1-2.814.382,3.032,3.032,0,0,0-.618.693,2.754,2.754,0,0,0-.269.53,1.938,1.938,0,0,0-.126.662,1.445,1.445,0,0,0,.174.7,1.721,1.721,0,0,0,.935.758,4.546,4.546,0,0,0,1.607.24q.175,0,.362-.008a.539.539,0,1,0-.043-1.077q-.168.007-.319.007a2.785,2.785,0,0,1-1.421-.265.477.477,0,0,1-.175-.171.365.365,0,0,1-.042-.181,1.1,1.1,0,0,1,.168-.518l.145.019a1.067,1.067,0,0,0-.179.494.241.241,0,0,0,.026.124.348.348,0,0,0,.129.121,2.523,2.523,0,0,0,1.328.244h.02c.1,0,.2,0,.315-.007h.027a.674.674,0,0,1,.027,1.347c-.125,0-.249.008-.368.008h0a4.961,4.961,0,0,1-1.514-.2v7.834a.833.833,0,0,0,1.666,0v-6.082h.312v6.082a.833.833,0,0,0,1.666,0V166.939c.035.037.071.076.109.119Z",
    transform: "translate(2240.951 -2023.069)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M231.055,108.009a1.516,1.516,0,1,1-1.516-1.516,1.516,1.516,0,0,1,1.516,1.516",
    transform: "translate(2220.341 -1966.185)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M84.245,431.307a.674.674,0,0,0,1.288-.4l-1.11-3.6a10.189,10.189,0,0,1-1.285.405Z",
    transform: "translate(2360.886 -2275.28)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M.269,233.2a4.828,4.828,0,0,0,1,.1A9.423,9.423,0,0,0,5.709,232a7.5,7.5,0,0,1-.609-1.066H5.092a.609.609,0,0,1-.279-.068,4.782,4.782,0,0,1-2.067-1.922A3.693,3.693,0,0,1,2.3,227.2a2.732,2.732,0,0,1,.056-.587.6.6,0,0,1,.59-.469.606.606,0,0,1,.591.741h0v.007c0,.011-.005.03-.009.056a1.941,1.941,0,0,0-.015.251,2.483,2.483,0,0,0,.3,1.173,3.025,3.025,0,0,0,.738.884c-.053-.261-.091-.514-.12-.754a7.44,7.44,0,0,0-.394-2.365,1.365,1.365,0,0,0-1.145-.634,1.374,1.374,0,0,0-.169-.011,1.484,1.484,0,0,0-1.179.681,5.552,5.552,0,0,0-.8,1.718,20.2,20.2,0,0,0-.684,4.1c-.042.564-.057.981-.062,1.142l.016.005c.056.017.141.041.253.065Z",
    transform: "translate(2440.985 -2080.833)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M58.984,140.048a1.516,1.516,0,1,1-1.763-1.218,1.516,1.516,0,0,1,1.763,1.218",
    transform: "translate(2387.053 -1997.316)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M67.9,249.152a2.612,2.612,0,0,1-.317-1.237,2.093,2.093,0,0,1,.016-.268c0-.03.007-.052.01-.064l0-.011h0a.472.472,0,0,0-.919-.213,2.6,2.6,0,0,0-.053.557,3.556,3.556,0,0,0,.43,1.685,4.593,4.593,0,0,0,2.01,1.866.472.472,0,0,0,.434-.837,3.65,3.65,0,0,1-1.614-1.476Z",
    transform: "translate(2376.779 -2101.552)",
    fill: "#a0a0a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.494321d1fd2366bdfe07523eb2c5ad2e.svg";
export { ForwardRef as ReactComponent };